import React from 'react';
import './PreferencesPane.css';

const PreferencesPane = ({ localPreferences, onChange, onReset }) => (
  <>
    <section className="settings-modal__section">
      <h3 className="settings-modal__section-title">Auto-Archive</h3>

      <div className="settings-modal__setting">
        <div className="settings-modal__setting-row">
          <div className="settings-modal__setting-text">
            <label className="settings-modal__label">Auto-archive completed missions</label>
            <p className="settings-modal__description">
              Automatically archive missions that have been completed with no activity
            </p>
          </div>
          <button
            className={`settings-modal__toggle ${localPreferences.autoArchiveEnabled ? 'settings-modal__toggle--active' : ''}`}
            onClick={() => onChange('autoArchiveEnabled', !localPreferences.autoArchiveEnabled)}
            role="switch"
            aria-checked={localPreferences.autoArchiveEnabled}
          >
            <span className="settings-modal__toggle-knob" />
          </button>
        </div>
      </div>

      {localPreferences.autoArchiveEnabled && (
        <div className="settings-modal__setting">
          <div className="settings-modal__setting-header">
            <label className="settings-modal__label">Days until auto-archive</label>
            <span className="settings-modal__value">
              {localPreferences.autoArchiveDays} {localPreferences.autoArchiveDays === 1 ? 'day' : 'days'}
            </span>
          </div>
          <p className="settings-modal__description">
            How long a completed mission must be inactive before archiving
          </p>
          <input
            type="range"
            className="settings-modal__slider"
            min="1"
            max="30"
            step="1"
            value={localPreferences.autoArchiveDays}
            onChange={(e) => onChange('autoArchiveDays', parseInt(e.target.value, 10))}
          />
          <div className="settings-modal__slider-labels">
            <span>1 day</span>
            <span>30 days</span>
          </div>
        </div>
      )}
    </section>

    <section className="settings-modal__section">
      <h3 className="settings-modal__section-title">Trackpad & Mouse</h3>

      <div className="settings-modal__setting">
        <div className="settings-modal__setting-header">
          <label className="settings-modal__label">Pan Sensitivity</label>
          <span className="settings-modal__value">
            {(localPreferences.trackpadPanSensitivity * 100).toFixed(0)}%
          </span>
        </div>
        <p className="settings-modal__description">
          How fast the view moves when scrolling with two fingers
        </p>
        <input
          type="range"
          className="settings-modal__slider"
          min="0.25"
          max="3"
          step="0.05"
          value={localPreferences.trackpadPanSensitivity}
          onChange={(e) => onChange('trackpadPanSensitivity', parseFloat(e.target.value))}
        />
        <div className="settings-modal__slider-labels">
          <span>Slow</span>
          <span>Fast</span>
        </div>
      </div>

      <div className="settings-modal__setting">
        <div className="settings-modal__setting-header">
          <label className="settings-modal__label">Zoom Sensitivity</label>
          <span className="settings-modal__value">
            {(localPreferences.trackpadZoomSensitivity * 100).toFixed(0)}%
          </span>
        </div>
        <p className="settings-modal__description">
          How fast the view zooms when pinching
        </p>
        <input
          type="range"
          className="settings-modal__slider"
          min="0.25"
          max="3"
          step="0.05"
          value={localPreferences.trackpadZoomSensitivity}
          onChange={(e) => onChange('trackpadZoomSensitivity', parseFloat(e.target.value))}
        />
        <div className="settings-modal__slider-labels">
          <span>Slow</span>
          <span>Fast</span>
        </div>
      </div>
    </section>

    <div className="settings-modal__pane-actions">
      <button className="settings-modal__reset" onClick={onReset}>
        Reset preferences
      </button>
    </div>
  </>
);

export default PreferencesPane;
